// Password generation utility
export const generateSecurePassword = (length: number = 12): string => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
  let password = '';
  
  // Ensure at least one character from each category
  password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]; // Uppercase
  password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; // Lowercase
  password += '0123456789'[Math.floor(Math.random() * 10)]; // Number
  password += '!@#$%^&*'[Math.floor(Math.random() * 8)]; // Special character
  
  // Fill the rest randomly
  for (let i = 4; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)];
  }
  
  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('');
};

// Email template for new barman credentials
export const createBarmanEmailTemplate = (
  firstName: string,
  lastName: string,
  username: string,
  password: string,
  eventName: string
): string => {
  return `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2 style="color: #333;">¡Bienvenido a Prior!</h2>
      
      <p>Hola ${firstName} ${lastName},</p>
      
      <p>Has sido agregado como barman al evento: <strong>${eventName}</strong></p>
      
      <p>Aquí están tus credenciales de acceso:</p>
      
      <div style="background-color: #f5f5f5; padding: 20px; border-radius: 8px; margin: 20px 0;">
        <p><strong>Usuario:</strong> ${username}</p>
        <p><strong>Contraseña:</strong> ${password}</p>
      </div>
      
      <p><strong>Importante:</strong> Por seguridad, te recomendamos cambiar tu contraseña después de tu primer inicio de sesión.</p>
      
      <p>Puedes acceder a la plataforma en: <a href="${window.location.origin}">${window.location.origin}</a></p>
      
      <p>Si tienes alguna pregunta, no dudes en contactar al organizador del evento.</p>
      
      <p>¡Gracias por ser parte de nuestro equipo!</p>
      
      <p>Saludos,<br>El equipo de Prior</p>
    </div>
  `;
};
